module.exports = __webpack_public_path__ + "static/media/avatar_36.c947e0e2.svg";